import { computed, type ComputedRef } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { usePlatform } from '@previo/design-system'
import { Flag, useFeatureFlags } from '@previo/feature-flags'
import { useUserStore } from '~/store/user'
import { useVersionSwitchAPI } from '~/components/version-switch/http/VersionSwitchAPI'

type TPmsVersionOverrideComposable = {
  isForced: ComputedRef<boolean>
  isLocked: ComputedRef<boolean>
  release: () => Promise<void>
}

export const usePmsVersionOverride = createGlobalState((): TPmsVersionOverrideComposable => {
  const isLockedByFlag = useFeatureFlags().isEnabled(Flag.AUTOMATIC_REDIRECT_TO_P2_PMS_ENABLED)
  const { user } = storeToRefs(useUserStore())
  const deviceType = usePlatform().getDeviceType()

  const isForced = computed<boolean>(
    () => isLockedByFlag.value || user.value.isForcedToNewPmsVersion(deviceType),
  )

  const isLocked = computed<boolean>(
    () => isLockedByFlag.value || !user.value.canSwitchPmsVersion(deviceType),
  )

  const release = async (): Promise<void> => {
    await useVersionSwitchAPI().switchBack(deviceType)

    user.value.releasePmsVersionOverride(deviceType)
  }

  return { isForced, isLocked, release }
})
